import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToCartError',
  props: {
    errorText: null,
    errorDetail: null
  },
  setup(__props: any) {

const props = __props as {
	errorText:string,
	errorDetail: string
}




return { __sfc: true,props }
}

})